<template>
    <div>
        <Toast position="center" group="ct" />
        <Toast position="top-left" group="tl" />
        <Toast position="top-center" group="tc" />
        <Toast position="top-right" group="tr" />
        <Toast position="bottom-left" group="bl" />
        <Toast position="bottom-center" group="bc" />
        <Toast position="bottom-right" group="br" />
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { Websocket } from '../composables/socket';
import { useGlobalStore } from '../stores/useGlobalStore';
import { useToast } from 'primevue/usetoast';
const { global, broadcast } = storeToRefs(useGlobalStore());
const { echo } = Websocket();
const toast = useToast();

const hasBroadcastEvent = (scope) => 'function' === typeof broadcast.value?.[scope];

/**
 * 廣播事件定義
 * hc_on_refresh 重新處理目前的程序
 */
//HC私頻
echo.join(`${global.value.broadcast}hc-private-${global.value.myid}`)
    // .joining((user) => {
    //     console.log('joining', user);
    // })
    // .leaving((user) => {
    //     console.log('leaving', user);
    // })
    .listen(`.${global.value.broadcast}hc.message`, (s) => {
        console.log('presence', s);

        //全域廣播事件
        if (hasBroadcastEvent('private')) {
            broadcast.value.private.call(null, s.message);
        }

        if (s?.message) {
            toast.add({
                severity: 'contrast',
                summary: '訊息',
                detail: s.message,
                life: 3000,
                group: 'br',
            });
            //過濾 user_online 通知
            global.value.notify.unshift(s);
        }
    });

//HC公頻
echo.channel(`${global.value.broadcast}hc-public`)
    .listen(`.${global.value.broadcast}hc.broadcast`, (s) => {

        //全域廣播事件
        // if (hasBroadcastEvent('public')) {
        //     broadcast.value.public.call(null, s.message);
        // }

        if (!s?.message) {
            getUserOnline();
            return;
        }

        if ('user_online' === s?.type) {
            return;
        }

        toast.add({
            severity: 'info',
            summary: '系統通知',
            detail: s.message,
            life: 3000,
            group: 'br',
        });

        //過濾 user_online 通知
        global.value.notify.unshift(s);

    });


</script>
